export default __webpack_public_path__ + "static/media/nuis.67614e9e.svg";